<div (click)="routingService.open('/main/grazing-patterns')"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    <div class=" d-flex justify-content-between">
        <div class=" fs-main fw-bold mb-3">Grazing patterns</div>
        <div class=" mt-auto mb-auto">
            <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
        </div>
    </div>
    <div class="row">
        <div class="col col-auto">
            <app-moovement-svg [colored]="true"
                               [height]="'30px'"
                               [width]="'30px'"
                               class="img-fluid img-max m-auto"></app-moovement-svg>
        </div>
    </div>
</div>
